import { register } from '../../../../Javascript/Sysmex/Utils'

const Navigation = el => {
  const componentPrefix = el.dataset.componentprefix
  const navigationSubList = el.querySelectorAll(`.${componentPrefix}navigationSubList`)

  function equalizeMegaMenuItemHeights () {
    navigationSubList.forEach(item => {
      const subMenuLinks = item.querySelectorAll(`.${componentPrefix}navigationSubListItem > a`)

      if (subMenuLinks.length === 0) {
        return
      }

      subMenuLinks.forEach(item => {
        item.style.height = ''
      })

      let maxHeight = 0
      subMenuLinks.forEach(item => {
        if (item.clientHeight > maxHeight) {
          maxHeight = item.clientHeight
        }
      })

      subMenuLinks.forEach(item => {
        if (maxHeight > 0) {
          item.style.height = `${maxHeight}px`
        }
      })
    })
  }

  equalizeMegaMenuItemHeights()

  window.addEventListener('resize', equalizeMegaMenuItemHeights)
}

register('Navigation', Navigation)
